import { Inter, Lato } from 'next/font/google';

// 'next/font' types don't seem to be exported correctly
// this is not ideal, but works
type NextFont = ReturnType<typeof Inter> | ReturnType<typeof Lato>;

export const lato = Lato({
  weight: ['400', '700', '900'],
  subsets: ['latin'],
});
export const inter = Inter({ subsets: ['latin'] });

export type GoogleFontKey = 'inter' | 'lato';
export const GOOGLE_FONTS: Record<GoogleFontKey, NextFont> = {
  lato,
  inter,
};
